import React from 'react';

import { gql } from '@apollo/client';
import { useTranslation } from '@modernloop/i18n';

import { ActivityLogEmployeeEmailSent_ActivityLogFragment } from 'src/generated/mloop-graphql';

import { FCWithFragments } from 'src/components/types';

import logError from 'src/utils/logError';

import ActivityLogBase from '../../Helpers/ActivityLogBase';
import ActivityLogFeedEmail from '../ActivityLogFeedEmail';

interface Fragments {
  activityLog: ActivityLogEmployeeEmailSent_ActivityLogFragment;
}

type EmployeeEmailSentDetails = {
  __typename?: 'ActivityLogEmployeeEmailSentDetails';
  toEmailAddress: string;
  ccAddresses: string[];
  subject: string;
  body: string;
};

const ActivityLogEmployeeEmailSent: FCWithFragments<Fragments> = ({ activityLog }) => {
  const { t } = useTranslation();
  const details = activityLog.details as unknown as EmployeeEmailSentDetails | null | undefined;

  // eslint-disable-next-line no-underscore-dangle
  if (details?.__typename !== 'ActivityLogEmployeeEmailSentDetails') {
    logError('ActivityLogEmployeeEmailSent: details is not ActivityLogEmployeeEmailSentDetails');
    return null;
  }

  return (
    <ActivityLogBase
      activityLog={activityLog}
      actionLabelKey="hiring-dashboard-candidates:candidates.activityLog.emailedAnEmployee"
    >
      <ActivityLogFeedEmail
        emailAddress={details.toEmailAddress}
        emailAddressLabel={t('hiring-dashboard-candidates:candidates.activityLog.to', { defaultValue: 'To:' })}
        ccAddresses={details.ccAddresses}
        subject={details.subject}
        body={details.body}
      />
    </ActivityLogBase>
  );
};

ActivityLogEmployeeEmailSent.fragments = {
  activityLog: gql`
    ${ActivityLogBase.fragments.activityLog}
    fragment ActivityLogEmployeeEmailSent_activityLog on ActivityLog {
      id
      activityType
      details {
        ... on ActivityLogEmployeeEmailSentDetails {
          __typename
          employeeId
          employeeName
          fromEmailAddress
          toEmailAddress
          ccAddresses
          subject
          body
        }
      }
      ...ActivityLogBase_activityLog
    }
  `,
};

export default ActivityLogEmployeeEmailSent;
